/* eslint-disable @typescript-eslint/no-explicit-any */
import { BTC_CHAIN_ID } from '../../../utils/constants';
import { AbstractWalletConnector } from '../../core/AbstractWalletConnector';
import { ChainTypes } from '../../core/types';
import { addListener, isBrowser } from '../../misc';

export class BtcConnector extends AbstractWalletConnector {
  readonly chainType = ChainTypes.BTC as const;

  private _provider?: any;
  public get provider() {
    return this._provider;
  }

  private _getProvider: () => Promise<any>;

  constructor(name: string, _provider: unknown) {
    super(name);
    this._chainId = BTC_CHAIN_ID;
    this._getProvider = async () => {
      const provider = typeof _provider === 'function' ? await _provider() : _provider;
      if (!provider) {
        return;
      }
      if (typeof provider === 'string') {
        return isBrowser ? window[provider] : undefined;
      }
      if (typeof provider === 'object') {
        return provider;
      }
      return;
    };
  }

  private _unSubscribeProvider: (() => void) | undefined;
  private _subscribeProvider(provider: any) {
    this._unSubscribeProvider?.();
    if (!provider.on) {
      return;
    }
    const removeAccountChange = addListener(provider, 'accountChanged', (accounts: string[]) => {
      this.address = accounts?.[0];
    });
    const removeDisconnect = addListener(provider, 'disconnect', () => {
      this.address = undefined;
    });

    const unSubscribe = () => {
      removeAccountChange();
      removeDisconnect();
      this._unSubscribeProvider = undefined;
    };
    this._unSubscribeProvider = unSubscribe;
  }

  async connect(recovery = false) {
    const provider = await this.getProvider();
    if (!provider) {
      throw new Error(`${this.name} provider not found or not ready`);
    }
    const accounts: any[] = recovery && provider.getAccounts ? await provider.getAccounts() : await provider.requestAccounts();
    const account = accounts?.[0];
    this.address = typeof account === 'string' ? account : account?.address;
    return this.address;
  }

  async disconnect() {
    this.address = undefined;
    this.publicKey = undefined;
    const provider = (await this.getProvider()) as any;
    if (typeof provider?.disconnect === 'function') {
      await provider?.disconnect();
    }
    return;
  }

  async getProvider(force = false): Promise<any> {
    if (!this._provider || force) {
      const eipProvider = await this._getProvider();
      if (eipProvider) {
        this._provider = eipProvider;
        this._subscribeProvider(eipProvider);
      } else {
        this._provider = undefined;
      }
    }
    return this._provider;
  }

  async isAvailable() {
    const provider = await this.getProvider();
    return Boolean(provider);
  }
}
